import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AlertService} from '../_services';
import { VerifyMemberInfo } from '../_models/verify-member-info';
import { ApiService } from '../_services/api.service';
import { AppComponent } from '../app.component';

export class PasswordValidation {

    static MatchPassword(AC: AbstractControl):any {
       let password = AC.get('password').value; // to get value in input tag
       let confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
        if(password != confirmPassword) {
            console.log('false');
            AC.get('confirmPassword').setErrors( {MatchPassword: true} )
        } else {
            console.log('true');
            return null
        }
    }
}

@Component(
    {templateUrl: 'register.component.html',
    styleUrls: ['register.component.scss']
})
export class RegisterComponent implements OnInit {
    registerForm: FormGroup;
    verifyMemberForm: FormGroup;
    loading = false;
    submitted = false;
    verifyMemberInfo: VerifyMemberInfo;
    currentProductId: number;
    minorMember: any;
    isMemberVerified: boolean = false;
    showLogin:boolean = false;
    adult : any = {};
 
    step = 1;
    checkingAdult = false;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private apiService: ApiService,
        private alertService: AlertService) {
            this.verifyMemberInfo = new VerifyMemberInfo();
         }

    ngOnInit() {
        this.registerForm = this.formBuilder.group({
            // firstName: ['', Validators.required],
            // lastName: ['', Validators.required],
            username: ['', Validators.required],
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', Validators.required]
        }, {
            validator: PasswordValidation.MatchPassword // your validation method
          });

          this.verifyMemberForm = this.formBuilder.group({
            // firstName: ['', Validators.required],
            // lastName: ['', Validators.required],
            memberId: ['', Validators.required],
            groupNumber: ['', Validators.required],
            zipCode: ['', Validators.required]
          });
    }

    // afterViewInit(){
    //     this.isMemberVerified = false;
    // }

    // convenience getter for easy access to form fields
    get f() { return this.registerForm.controls; }

    verifyMember(){
        this.loading = true;
        this.apiService.verifyMember( AppComponent.whitelabel.productId,this.verifyMemberInfo).subscribe(r=>{
            
            if(!r){
                this.alertService.error('Sorry, we can not find this member', false)

            }else{

                if(new Date().getFullYear() - new Date(r.dob).getFullYear() >= 18){
                    this.isMemberVerified = true;
                    this.step = 3;
                    this.alertService.success('Enter your email address and select a password', false)
                }else{
                    this.step = 2;
                    this.minorMember = r;
                }
                
            }
            this.loading = false;
        },err=>{
            if(err.code == 'verify-2'){

                this.showLogin = true;
            }else{
                this.alertService.error(err.message, false)
            }
            this.loading = false;
        })
    }

    checkAdult(){
        if(new Date().getFullYear() - new Date(this.adult.dob).getFullYear() < 18){
            this.alertService.error('Adult/Parent is under 18.', false);
            return;
        }
        this.checkingAdult = true;
        //submit adult from minor
        this.apiService.submitAdultFromMinor({adult: this.adult, minorMember: this.minorMember}).subscribe(r=>{
            this.isMemberVerified = true;
            this.step = 3;
            this.alertService.success('Enter your email address and select a password', false);
            this.checkingAdult = false;
        }, err=>{
            this.checkingAdult = false;
            this.alertService.error(err.error);
        })
    }

    adultChanged(){
        this.alertService.clear()
    }

    onSubmit() {
        this.submitted = true;
        this.registerForm.value.memberId = this.verifyMemberInfo.memberId;
        // stop here if form is invalid
        if (this.registerForm.invalid) {
            return;
        }

        this.loading = true;

        this.apiService.create(this.registerForm.value)
            .subscribe(
                data => {
                    this.alertService.success('Registration successful.  Please check your email for an email with the subject “Please verify your LIFE Association Gateway account. If it is not in your Inbox, please check your Junk Mail (SPAM) or Clutter folder for the email.', true);
                    this.router.navigate(['/login']);
                },
                err => {
                    this.alertService.error(err.error);
                    this.loading = false;
                });
    }
}



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts